import { useLocation } from "react-router-dom"
import { getCurrentRouteContext } from "@/lib/utils/route"
import { useTheme } from "next-themes"
import { useEffect, useState } from "react"
import Sidebar from "@/pages/dashboard/components/sidebar"

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const { theme } = useTheme()
  const [mounted, setMounted] = useState(false)
  const location = useLocation()
  const routeContext = getCurrentRouteContext(location)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  // If route doesn't show nav or sidebar, render children directly
  if (!routeContext.showNav && !routeContext.showSideBar) {
    return <>{children}</>
  }

  return (
    <div className={`flex h-screen ${theme === "dark" ? "dark" : ""}`}>
      {routeContext.showSideBar && <Sidebar />}
      <div className="flex w-full flex-1 flex-col">
        <main className="h-[500px] flex-1 overflow-auto rounded-tl-lg bg-white dark:bg-[#0F0F12]">{children}</main>
      </div>
    </div>
  )
}
